import { Link } from "react-router-dom";
import bg from "assets/img/homepage/hero-bg-bottom.png";
import bgMobile from "assets/img/homepage/hero-bg-bottom@mobile.png";
import logo from "assets/img/homepage/logo-giant.svg";

const HomepageHero = ({ activateLogin }) => {
  return (
    <div className="homepage-hero" id="home">
      <section className="homepage-hero__section">
        <h1 className="homepage-hero__title">
          <b>Open Beta is Live!</b>
          <span>Know Football? Prove it!</span>
          <span>Play the TwoTwentyK</span>
          <span className="yellow">2025 Pro Football Prediction Game</span>
        </h1>
        <nav className="homepage-hero__actions">
          <Link
            onClick={(e) => {
              e.preventDefault();
              activateLogin();
            }}
          >
            Play now
          </Link>
          {/* <Link to="privacies/learn-to-play">Learn to Play</Link> */}
        </nav>
        <footer className="homepage-hero__footer">
          <picture>
            <source srcSet={bgMobile} media="(max-width: 767px)" />
            <img src={bg} alt="" className="homepage-hero__footer-bg" />
          </picture>
          <img src={logo} className="homepage-hero__footer-logo" alt="" />
        </footer>
      </section>
    </div>
  );
};

export default HomepageHero;
